// src/pages/Usuarios.js
import React, { useState, useEffect, useContext } from "react";
import {
  PlusOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import {
  Typography,
  Table,
  Spin,
  message,
  Card,
  Button,
  Space,
  Modal,
  Form,
  Input,
  Select,
  Popconfirm
} from "antd";
import { AppContext } from "../context/AppContext";
import { request } from "../services/api";

const { Title } = Typography;

const Users = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { hasSettingsAccess } = useContext(AppContext);
  const [form] = Form.useForm();
  const [pin, setPin] = useState(null);

  useEffect(() => {
    cargarDatos();
    // eslint-disable-next-line
  }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const response = await request(
        `/management/users/retrieve`,
        { method: "GET" }
      );
      const datosConKey = response.map((item, index) => ({
        ...item,
        key: item.id || index
      }));
      setData(datosConKey || []);
    } catch (error) {
      messageApi.error("No se pudieron cargar los datos");
    } finally {
      setLoading(false);
    }
  };

  const generatePin = () => {
    try {
      const array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      const secureCode = (array[0] % 100000000).toString().padStart(8, "0");
      setPin(secureCode);
      form.setFieldsValue({
        pin: secureCode
      });
    } catch (error) {
      messageApi.error("No se pede generar el pin");
    }
  };

  const resetPin = () => {
    form.setFieldsValue({
        pin: ""
      });
  }

  const handleCreate = async (values) => {
    try {
      setLoading(true);
      let datosAEnviar = { ...values };
      if (!values.role) {
        datosAEnviar.role = "user";
      }
      datosAEnviar.userAssignedPin = Number(values.pin);
      console.log(datosAEnviar)
      await request("/management/users/create", {
        method: "POST",
        body: JSON.stringify(datosAEnviar)
      });
      messageApi.success(`Registro creado`);
      setIsModalOpen(false);
      form.resetFields();
      cargarDatos();
    } catch (error) {
      messageApi.error("Error al crear contacto");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (recordAEliminar) => {
    console.log(recordAEliminar)
    const { userAssignedPin } = recordAEliminar;
    try {
      setLoading(true);
      await request(
        `/management/users/remove?pin=${userAssignedPin}`,
        {
          method: "DELETE"
        }
      );
      messageApi.success("Usuario eliminado");
      cargarDatos();
    } catch (error) {
      messageApi.error("No se pudo eliminar");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { title: "Nombre", dataIndex: "name", key: "name" },
    { title: "Apellido(s)", dataIndex: "lastname", key: "lastname" },    
    {
      title: "Rol",
      dataIndex: "role",
      key: "role"
    },
    {
      title: "Remover",
      key: "remover",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            title="¿Eliminar usuario?"
            description={`¿Estás seguro de que deseas eliminar a ${record.name} ${record.lastname}?`}
            onConfirm={() => handleDelete(record)}
            okText="Sí, eliminar"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button type="text" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      )
    }
  ];

  const handleOk = () => {
    console.log("submitting");
    form.submit();
  };

  return (
    <div>
      {contextHolder}
      <Title level={2}>Gestión de Usuarios</Title>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
          Nuevo Usuario
        </Button>
      </Space>
      <Card>
        <Spin spinning={loading} tip="Cargando información...">
          <Table
            dataSource={data}
            columns={columns}
            rowKey="key"
            pagination={false}
          />
        </Spin>
      </Card>
      <Modal
        title="Agregar Nuevo Usuario"
        open={isModalOpen}
        onCancel={() => {
          resetPin();
          setIsModalOpen(false);
        }}
        onOk={handleOk}
        confirmLoading={loading}
        okText="Guardar"
        cancelText="Cancelar"
        okButtonProps={{ style: { background: "#000" } }}
        forceRender={true}
        destroyOnHidden
      >
        <Form form={form} layout="vertical" onFinish={handleCreate}>
          <Form.Item
            name="name"
            label="Nombre(s)"
            rules={[
              { required: true, message: "Ingresa el nombre del contacto" }
            ]}
          >
            <Input placeholder="ejemplo: Miguel Angel" />
          </Form.Item>

          <Form.Item
            name="lastname"
            label="Apellido(s)"
            rules={[
              { required: true, message: "Ingresa el apellido del contacto" }
            ]}
          >
            <Input placeholder="ejemplo: Sandoval" />
          </Form.Item>

          <Form.Item
            name="pin"
            label="Pin"
            initialValue={{ pin: pin }}
            rules={[
              {
                required: true,
                message: "Agrega un Pin númerico de 8 dígitos"
              }
            ]}
          >
            <Space>
              <Input disabled placeholder={pin} />
              <Button htmlType="button" onClick={generatePin}>
                Generar Pin
              </Button>
            </Space>
          </Form.Item>
          {hasSettingsAccess ? (
            <Form.Item name="role" label="Rol">
              <Select
                options={[
                  { value: "user", label: "Usuario" },
                  { value: "admin", label: "Administrador" }
                ]}
              />
            </Form.Item>
          ) : null}
        </Form>
      </Modal>
    </div>
  );
};

export default Users;
